export const theme = {
  colors: {
    primary: '#6B8E23',        // 올리브 그린 - 따뜻하고 자연스러운 초록
    primaryLight: '#8FBC8F',   // 연한 시그린
    primaryDark: '#556B2F',    // 다크 올리브
    secondary: '#D2691E',      // 초콜릿 브라운 - 흙, 자연의 느낌
    secondaryLight: '#CD853F', // 페루 브라운
    accent: '#F4A460',         // 샌디 브라운 - 따뜻한 액센트
    background: '#FAF8F3',     // 아이보리 화이트 - 따뜻한 배경
    white: '#FFFFFF',
    text: '#3E2723',           // 다크 브라운 - 따뜻한 텍스트
    textLight: '#6D4C41',      // 밀크 초콜릿 브라운
    border: '#E8DCC4',         // 베이지 - 부드러운 경계
    success: '#6B8E23',
    warning: '#DAA520',        // 골든로드
    error: '#C1502E'           // 따뜻한 레드
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    full: '9999px'
  },
  shadows: {
    sm: '0 2px 4px rgba(107, 142, 35, 0.08), 0 1px 2px rgba(62, 39, 35, 0.06)',
    md: '0 4px 8px rgba(107, 142, 35, 0.1), 0 2px 4px rgba(62, 39, 35, 0.08)',
    lg: '0 10px 20px rgba(107, 142, 35, 0.12), 0 4px 8px rgba(62, 39, 35, 0.08)',
    xl: '0 15px 30px rgba(107, 142, 35, 0.15), 0 6px 12px rgba(62, 39, 35, 0.1)'
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease'
  }
};

export type Theme = typeof theme;